// extracted by mini-css-extract-plugin
export default {"container":"FoodFormatSection-module__container__CQFI7","text":"FoodFormatSection-module__text__qkcGT","switch-layout":"FoodFormatSection-module__switch-layout__I9CGK"};